import React, {Component} from 'react';
import {Card, Layout, List} from 'antd';
import {isMobilityRental, TIRES, TIRES_EXCHANGE,} from '../definition/business';
import N_OfficialDocumentSectionFragment from './sectionFragment/N_OfficialDocumentSectionFragment';
import N_ServicesSectionFragment from './sectionFragment/N_ServicesSectionFragment';
import {DisplaySectionFragment} from './sectionFragment/displaySectionFragment';
import {ItemSectionFragment} from './sectionFragment/itemSectionFragment';
import Address from "../../../components/common/Address";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class SummaryFragment extends Component {
  renderItem = (title, description) => (
    <List.Item>
      <List.Item.Meta title={title} description={description} />
    </List.Item>
  );

  render() {
    const {
      intl:{formatMessage},
      reception,
      number,
      street,
      zipCode,
      city,
      country,
      licenseId,
      licenseDeliveryDate,
      idCardNumber,
      birthDate,
      nationality,
      validity,
      mobility,
      type,
      createAppointmentRequest,
    } = this.props;
    const {selectedOptions=[],chosenMobility} = createAppointmentRequest;
    const isTiresWheelsType = type === TIRES;
    const isTiresExchangeChecked = !!selectedOptions.find(o => o.id === TIRES_EXCHANGE)
    const shouldShowExtra = chosenMobility && isMobilityRental(chosenMobility.mobilityOption, mobility.categoryMobility);
    const receptionText = `customer.journey.step.dateReception.${reception}Reception`;

    return (
      <Layout style={{ backgroundColor: 'transparent' }}>
        <Card
          title={<h2>{formatMessage({ id: 'customer.journey.step.summary.title' }).toUpperCase()}</h2>}
          bordered={false}
          style={{ width: '100%', marginBottom: 25 }}
        >
          <DisplaySectionFragment
            title={formatMessage({ id: 'customer.journey.step.summary.chosenService' })}
          >

            <N_ServicesSectionFragment/>
          </DisplaySectionFragment>
          {!isTiresWheelsType && (
            <DisplaySectionFragment
              title={formatMessage({
                id: 'customer.journey.step.summary.chosenMobility',
              })}
            >
              <ItemSectionFragment title={formatMessage({ id: chosenMobility.mobilityOptionTitle })} />
            </DisplaySectionFragment>
          )}
          {!isTiresWheelsType && (
            <DisplaySectionFragment
              title={formatMessage({
                id: 'customer.journey.step.summary.chosenReception',
              })}
            >
              <ItemSectionFragment title={formatMessage({ id: receptionText })} />
            </DisplaySectionFragment>
          )}
          {(!isTiresWheelsType || isTiresExchangeChecked) && shouldShowExtra && number && (
            <DisplaySectionFragment
              title={formatMessage({ id: 'customer.journey.step.summary.yourAddress' })}
            >
              <Address address={{street, number, zipCode, city, country}}/>
            </DisplaySectionFragment>
          )}
          {(!isTiresWheelsType || isTiresExchangeChecked) && shouldShowExtra && licenseId && (
            <DisplaySectionFragment
              title={formatMessage({
                id: 'customer.journey.step.summary.yourOfficialInformation',
              })}
            >
              <N_OfficialDocumentSectionFragment
                licenseId={licenseId}
                licenseDeliveryDate={licenseDeliveryDate}
                idCardNumber={idCardNumber}
                birthDate={birthDate}
                nationality={nationality}
                validity={validity}
              />
            </DisplaySectionFragment>
          )}
        </Card>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
  createAppointmentRequest: state.createAppointmentRequest,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SummaryFragment)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/SummaryFragment.js